import moment from "moment-jalaali";


export const numberWithCommas = (x: string | number): string => {
    try {
        if (typeof x === "number") {
            x = Math.round(x).toString();
        }
        const inputString = fixNumbers(x.toString()).replace(/\D/g, '')
        const inputNumber = parseInt(inputString)
        if (isNaN(inputNumber)) return inputString
        const roundedNumber = Math.round(inputNumber)
        return roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch (error) {
        return x as string
    }
}
export const inputNumberToNumber = (x: string | number): number => {
    return Number(x.toString().replace(/,/g, ''));
}

const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]

export const fixNumbers = function (str) {
    if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
    return str;
};

function lighten(hex: string, percent: number) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + Math.round((255 - (num >> 16)) * percent);
    let g = ((num >> 8) & 0x00ff) + Math.round((255 - ((num >> 8) & 0x00ff)) * percent);
    let b = (num & 0x0000ff) + Math.round((255 - (num & 0x0000ff)) * percent);

    return "#" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export function stringToColor(string: string) {
    if (!string) return "#FFF";

    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return lighten(color, 0.4);
}

export const unixTimeToTime = (unixTime: number) => {
    const date = new Date(unixTime);
    const momentDate = moment(date);
    return momentDate?.format("HH:mm");
}

export const unixTimeToTimeAndDate = (unixTime: number | undefined | null) => {
    if (!unixTime || typeof unixTime !== "number") return "زمان نامعتبر است";

    const date = new Date(unixTime);

    const year = date.getFullYear();
    if (year < 1970 || year > 2100) return "تاریخ غیرمجاز";

    try {
        const momentDate = moment(date);
        return momentDate.format("HH:mm:ss - jYYYY/jMM/jDD");
    } catch (err) {
        return "خطا در تبدیل تاریخ";
    }
}

export const unixTimeToShortTimeAndDate = (unixTime: number | undefined | null) => {
    if (!unixTime || typeof unixTime !== "number") return "زمان نامعتبر است";

    const date = new Date(unixTime);
    const year = date.getFullYear();
    if (year < 1970 || year > 2100) return "تاریخ غیرمجاز";

    try {
        const momentDate = moment(date);
        return momentDate.format("HH:mm - jYYYY/jMM/jDD");
    } catch (err) {
        return "خطا در تبدیل تاریخ";
    }
};

export const unixTimeToDate = (unixTime: number | undefined | null) => {
    if (!unixTime || typeof unixTime !== "number") return "تاریخ نامعتبر";
    const date = new Date(unixTime);
    const year = date.getFullYear();
    if (year < 1970 || year > 2100) return "تاریخ نامعتبر";
    try {
        const momentDate = moment(date);
        return momentDate.format("jYYYY/jMM/jDD");
    } catch (err) {
        return "خطا در تبدیل تاریخ";
    }
};

export const base64ToUint8Array = (base64: string): Uint8Array => {
    if (!base64 || typeof base64 !== "string") {
        console.error("Invalid base64 input:", base64);
        return new Uint8Array();
    }

    try {
        const normalized = base64
            .replace(/-/g, "+")
            .replace(/_/g, "/")
            .padEnd(base64.length + (4 - (base64.length % 4)) % 4, "=");

        let rawData: string;

        if (typeof window !== "undefined" && typeof window.atob === "function") {
            rawData = window.atob(normalized);
        } else {
            rawData = Buffer.from(normalized, "base64").toString("binary");
        }

        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; i++) {
            outputArray[i] = rawData.charCodeAt(i);
        }

        return outputArray;
    } catch (err) {
        console.error("Failed to decode Base64:", base64, err);
        return new Uint8Array();
    }
};
